import React, { useState } from "react";
import { IconWrapper } from "../../Components/StyledComponents/StyledComponents";
import environmentVariables from "../../config/environmentVariables";
import styled from 'styled-components';
const LargeImage1 = `${environmentVariables?.cdnUrl}a1.jpg`;
const SmallImage1 = `${environmentVariables?.cdnUrl}a2.jpg`;
const LargeImage2 = `${environmentVariables?.cdnUrl}b1.jpg`;
const SmallImage2 = `${environmentVariables?.cdnUrl}b2.jpg`;
const LargeImage3 = `${environmentVariables?.cdnUrl}c1.jpg`;
const SmallImage3 = `${environmentVariables?.cdnUrl}c2.jpg`;

const Root = styled.div``;
const Container = styled.div`
  background-color:${(p) => p.theme.colors.cardBgColor};
  border-radius:${(p) => p.theme.radius.xs};
  margin:${(p) => p.theme.spacing.sm} auto;
  width:80%;
  padding:${(p) => p.theme.spacing.sm};
  display:flex;
  justify-content:space-between;
  height:420px;
  align-items:center;
  @media(min-width:1600px){
    height:500px;
  }
  @media(max-width:${(p) =>p.theme.screen.lg}){
    width:90%;
    height:380px;
}
  @media(max-width:${(p) =>p.theme.screen.md}){
      width:90%;
      height:350px;
  }
  @media(max-width:768px){
      width:calc(100% - 40px);
      margin:${(p) => p.theme.spacing.sm};
      height:100%;
      flex-direction:column;
      padding: 10px;
  }
`;   

const Icon = styled.img`
  width: 26px;
  height: 26px;
  aspect-ratio: auto 1/1;
`;


const TitalMain = styled.div`
    font-family: SweraDemo;
    color: #e3e3e3;
    font-size: 24px;
    font-weight: 900;
    margin-bottom: 30px;
    font-family: SweraDemo;
    color: #e3e3e3;
    margin: 0px auto;
    width: 80%;
    display: flex;
 @media(max-width:768px){
    
 }
`;
const ImageView = styled.div`
 width:calc(72% - 10px);
 /* border-radius:${(p) => p.theme.radius.xs}; */
 border-radius: 12px;
 height:100%;
 border: 1px solid #2d3539;
 @media(max-width:768px){
     width:100%;
 }
`;

const ListImage = styled.div`
width:calc(28% - 10px);
display:flex;
flex-direction:column;
 height:100%;
justify-content:space-between;
@media(max-width:768px){
    display:grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap:10px;
    width:100%;
    margin-top:10px;
}
`;
const ViewImage = styled.img`
width:100%;
block-size: fit-content;
height:380px;
border-radius:${(p) => p.theme.radius.sm};
@media(min-width:1600px){
    height:456px;  
}
@media(max-width:${(p) => p.theme.screen.lg}){
    height:340px;
}
@media(max-width:${(p) => p.theme.screen.md}){
    height:310px;
}
@media(max-width:${(p) => p.theme.screen.xxs}){
    height:200px;
}
`;
const Image = styled.img`
width:100%;
max-height:100px;
object-fit:fit-content;
border-radius:5px;
cursor:pointer;
${(p) => p.selected && `
   border:1px solid #303030;
`};
box-sizing:border-box;
@media(min-width:${(p) => p.theme.screen.lg}){
    height:120px;
    min-height:120px;
}
@media(min-width:1600px){
    max-height:140px;
}
@media(max-width:768px){
    height:60px;
}
`;

const GallerySection = () => {
    const [currentImage, setCurrentImage] = useState(LargeImage1);

    return (
        <Root>
            <TitalMain>
                <IconWrapper>
                    <Icon src={`${environmentVariables?.cdnUrl}metaicon.png`} />
                </IconWrapper>{" "}
                Glimpse of Metaspace
            </TitalMain>
            <Container>
                <ImageView>
                    <ViewImage src={currentImage} />
                </ImageView>
                <ListImage>
                    <Image
                        selected={currentImage === LargeImage1}
                        src={SmallImage1}
                        onClick={() => { setCurrentImage(LargeImage1)}} 
                    />
                    <Image
                        selected={currentImage === LargeImage2}
                        src={SmallImage2}
                        onClick={() => { setCurrentImage(LargeImage2) }} 
                    />
                    <Image
                        selected={currentImage === LargeImage3}
                        src={SmallImage3}
                        onClick={() => { setCurrentImage(LargeImage3)}} 
                     />
                </ListImage>
            </Container>
        </Root>
    );
};

export default GallerySection;